<template>
  <div class="home home-page v2_font_Montserrat v2_color_black_knight">
    <div class="welcome mt-3">
      <!--      WELCOME SECTION-->
      <div class="shadowed-box welcome-section pt-2 pb-5">
        <b-container fluid class="px-2 px-md-5 pt-3">
          <b-row class="px-2 px-md-0">
            <b-col>
              <p class="font_size_1750rem v2_font_weight_semibold">
                Welcome To Phairify!
              </p>
            </b-col>
          </b-row>
          <b-row class="px-2 px-md-0">
            <b-col>
              <p class="font_size_1000rem">
                Phairify provides recruiters and hospitals a platform to
                efficiently find and connect to doctors eager to see new job
                opportunities.
              </p>
            </b-col>
          </b-row>
          <b-row class="px-2 px-md-0 pt-2">
            <b-col md="8">
              <pre-paywall-recruiter-video />
            </b-col>
            <b-col
              md="4"
              class="v2_bg_alice_blue d-flex align-items-center justify-content-center flex-column mt-4 mt-md-0 py-4 py-md-0"
            >
              <span class="font_size_1325rem text-center px-5">
                Get started connecting with candidates.
              </span>
              <b-button
                variant="kowloon"
                class="mt-4"
                @click="gotoICO"
              >
                Get Started
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <!--      INFORM SECTION-->
      <div class="inform-section">
        <div class="inform-section_background">
          <img class="inform-section_img" :src="getImgUrl('teal_logo.png')" />
        </div>
        <b-row class="flex-grow-1">
          <b-col md="6">
            <b-carousel
              controls
              img-height="300"
              img-width="100"
              class="share-carousel"
            >
              <b-carousel-slide v-for="slide in informSlides" :key="slide">
                <template slot="img">
                  <img
                    class="d-block img-fluid"
                    height="300"
                    :src="getImgUrl(slide)"
                    alt="image slot"
                  />
                </template>
              </b-carousel-slide>
            </b-carousel>
          </b-col>
          <b-col md="6">
            <h2
              class="text-uppercase letter_spacing_28 v2_font_weight_semibold font_size_1750rem"
            >
              Inform
            </h2>
            <h3
              class="font_size_1750rem v2_font_weight_semibold opacity-50 my-3"
            >
              Access Specialty-Specific Market Intelligence
            </h3>
            <ul class="filled-list">
              <li>
                Review key specialty demographic statistics (age, gender, race,
                etc.)
              </li>
              <li>
                Access specialty-specific productivity, compensation, and
                practice intelligence
              </li>
              <li>Review candidate density in different geographic regions</li>
            </ul>
            <div class="quote-box text-center text-md-left v2_font_size_18">
              “Are the terms of my job offer consistent with the market?”
            </div>
            <div class="gray-box mt-3 d-flex flex-column flex-lg-row">
              <span class="text-center">
                Increase your knowledge of the specialty market.
              </span>
              <b-button
                variant="kowloon"
                @click="gotoICO"
                class="text-uppercase font_size_875rem mt-3 mt-lg-0"
              >
                Get Started
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <!--      CONNECT SECTION-->
      <div class="connect-section">
        <div class="connect-section_background">
          <img class="connect-section_img" :src="getImgUrl('teal_logo.png')" />
        </div>
        <b-row class="flex-grow-1">
          <b-col md="6">
            <h2
              class="text-uppercase letter_spacing_28 v2_font_weight_semibold font_size_1750rem"
            >
              Connect
            </h2>
            <h3
              class="font_size_1750rem v2_font_weight_semibold opacity-50 my-3"
            >
              Build Your Best Job Opportunity And Engage
            </h3>
            <ul class="filled-list">
              <li>
                Explore physicians on the platform who have indicated an
                interest in your opportunity
              </li>
              <li>
                Use Phairify’s specialty info to refine your job offer and
                maximize candidate appeal
              </li>
              <li>Push your job offer directly to interested physicians</li>
            </ul>
            <div class="gray-box d-flex flex-column flex-lg-row">
              <span class="text-center">
                Get started connecting to doctors that want your job
              </span>
              <b-button
                variant="kowloon"
                @click="gotoICO"
                class="text-uppercase font_size_875rem mt-3 mt-lg-0"
              >
                Get Started
              </b-button>
            </div>
          </b-col>
          <b-col md="6" class="mt-3 mt-md-0">
            <b-carousel
              controls
              img-height="300"
              img-width="100"
              class="share-carousel"
            >
              <b-carousel-slide v-for="slide in connectSlides" :key="slide">
                <template slot="img">
                  <img
                    class="d-block img-fluid"
                    height="300"
                    :src="getImgUrl(slide)"
                    alt="image slot"
                  />
                </template>
              </b-carousel-slide>
            </b-carousel>
          </b-col>
        </b-row>
      </div>
      <div>
        <call-to-action-section />
      </div>
    </div>
  </div>
</template>

<script>
import ImageUrlMixin from '@/mixins/ImageUrlMixin';
import PrePaywallRecruiterVideo from '@/components/pre-paywall-pages/recruiter/PrePaywallRecruiterVideo';
import CallToActionSection from '@/components/pre-paywall-pages/recruiter/CallToActionSection';

export default {
  name: 'PrePaywallRecruiterWelcome',
  mixins: [ImageUrlMixin],
  components: {
    PrePaywallRecruiterVideo,
    CallToActionSection,
  },
  data: function () {
    return {
      shareSlides: [
        'prepaywall/welcome/carousel/share/Share 1.png',
        'prepaywall/welcome/carousel/share/Share 2.png',
        'prepaywall/welcome/carousel/share/Share 3.png',
      ],
      informSlides: [
        'prepaywall/welcome/carousel/inform/Inform Graphic 1.png',
        'prepaywall/welcome/carousel/inform/Inform Graphic 2.png',
        'prepaywall/welcome/carousel/inform/Inform Graphic 3.png',
      ],
      connectSlides: [
        'prepaywall/welcome/carousel/connect/Connect Graphic 1.png',
        'prepaywall/welcome/carousel/connect/Connect Graphic 2.png',
      ],
    };
  },
  methods: {
    gotoICO: function () {
      //// Clear all before store ////
      this.$store.state.job_offer = undefined;
      this.$store.state.job_information = undefined;
      this.$store.state.show_payment_page = '';
      this.$store.state.is_new_offer = undefined;
      this.$store.state.location_zip_code = undefined;
      this.$store.state.specialtyId = undefined;
      
      this.$router.push('/recruiter/ico');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/v3';
.shadowed-box {
  box-shadow: 0 3px 20px #0000001a;
}
.welcome {
  padding: 0 2rem;
}
.share-section,
.inform-section,
.connect-section {
  position: relative;
  overflow: hidden;
  min-height: 642px;
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid $v3_color_teal;
  margin-top: 52px;
  padding: 0 50px;
  &_background {
    position: absolute;
    z-index: 0;
    overflow: hidden;
    bottom: 0;
    display: flex;
  }
  &_img {
    height: 110vh;
    filter: grayscale(100%) opacity(10%);
  }
}
.share-section,
.connect-section {
  &_background {
    right: -2%;
    top: -4%;
    left: 0;
    justify-content: end;
  }
}
.inform-section {
  &_background {
    left: -2%;
    top: -4%;
    right: 0;
    justify-content: start;
  }
}
ul.filled-list {
  list-style: none;
  padding-left: 2rem;
  li {
    position: relative;
    &::before {
      content: '\2022';
      position: absolute;
      top: 9px;
      left: 0;
      color: $v3_color_teal;
      font-weight: bold;
      display: inline-block;
      width: 1rem;
      margin-left: -1em;
      font-size: 2rem;
      letter-spacing: 0px;
      line-height: 0;
      height: 4px;
    }
  }
}
ul.empty-list {
  list-style: none;
  padding-left: 2.5rem;
  li {
    &::before {
      content: '\25CB';
      color: $v3_color_teal;
      font-weight: bold;
      display: inline-block;
      width: 1rem;
      margin-left: -1em;
      font-size: 0.8rem;
      letter-spacing: 0px;
      line-height: 0;
      height: 4px;
    }
  }
}
.gray-box {
  background: $v3_color_alice_blue;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.quote-box {
  background: $v3_color_alice_blue;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $v3_color_teal;
}
//sm
@media (max-width: 767px) {
  .shadowed-box {
    box-shadow: 0 3px 20px #00000070;
  }
  .welcome {
    padding: 0 0.5rem;
  }
  .share-section,
  .inform-section,
  .connect-section {
    padding: 10px 10px;
    &_img {
      height: 100vh;
      filter: grayscale(100%) opacity(3%);
    }
  }
  .share-section,
  .connect-section {
    &_background {
      top: -4%;
      bottom: inherit;
    }
  }
  .inform-section {
    &_background {
      bottom: -15%;
      top: inherit;
    }
  }
}
//md
@media (min-width: 768px) {
  .share-section,
  .inform-section,
  .connect-section {
    padding-top: 10px;
    padding-bottom: 10px;
    &_img {
      filter: grayscale(100%) opacity(10%);
    }
  }
}
//lg
@media (min-width: 991px) {
}
//xl
@media (min-width: 1200px) {
}
</style>
<style lang="scss">
.carousel {
  margin-bottom: 75px;
  & &-item {
    justify-content: center;
    visibility: hidden;
    display: flex;
    &.active,
    &-next,
    &-prev {
      display: flex;
    }
    &.active {
      visibility: visible;
    }
  }
  & &-control {
    &-prev,
    &-next {
      top: 100%;
      bottom: -50px;
      &-icon {
        background-image: none;
        width: 22px;
        height: 22px;
        transform: rotate(-45deg);
        border: 2px solid #2b2b2b;
        opacity: 1;
      }
    }
    &-prev {
      left: 30%;
      &-icon {
        border-right: 0;
        border-bottom: 0;
      }
    }
    &-next {
      right: 30%;
      &-icon {
        border-left: 0;
        border-top: 0;
      }
    }
  }
}
</style>
